<script setup>
  const { items, red } = defineProps({ items: Array, red: Boolean });
</script>

<!----------------------------------------------------------------------------->

<template>
  <div class="wrapper" :class="{ red }">
    <Ticker :speed="0.75" class="ticker" noSpacer>
      <span v-for="(item, index) in items"
        ><span>{{ item }}<Bullet /></span
      ></span>
    </Ticker>
  </div>
</template>

<!----------------------------------------------------------------------------->

<style lang="scss" scoped>
  .wrapper {
    background-color: $white;
    color: $black;

    height: px(30);
    @include heroic-bold(px(32));

    overflow: hidden;

    &.red {
      background-color: $red;
      color: $white;
    }

    .ticker {
      margin-top: 0.145em;

      span {
        display: block;

        display: inline-flex;
        align-items: center;

        i {
          margin-left: 0.4em;
          margin-right: 0.4em;
        }
      }
    }

    @include break-medium {
      height: 2.8vw;
      font-size: 2.8vw;

      .ticker {
        margin-top: 0.17em;
      }
    }

    @include break-small {
      height: px(24);
      font-size: px(24);

      .ticker {
        margin-top: 0.16em;
      }
    }
  }
</style>
